<template>
    <div class="index">
       
        <el-tabs type="border-card" @tab-click="changeTab">
            <el-tab-pane label="任务信息">
                <div class="section">
                    <div class="title">
                        基本信息
                    </div>
                    <div class="item">
                        <div class="label">
                            <span class="dot">*</span>
                            赔案号
                        </div>
                        <div class="value">
                            <el-input v-model="caseData.cClmNo" placeholder="请输入" size="small" class="citem-input"></el-input>
                        </div>
                    </div>

                    
                    <div class="item">
                        <div class="label">
                            调查意见
                        </div>
                        <div class="value" style="width:590px">
                            <el-input v-model="caseData.cDoubtOpin" placeholder="请输入" size="small" type="textarea"></el-input>
                        </div>
                    </div>
                    <div class="item">
                        <div class="label">
                            <span class="dot">*</span>
                            派工时间
                        </div>
                        <el-date-picker
                        v-model="caseData.dcTaskPgTime"
                        type="datetime"
                        size="small"
                        class="citem-input"
                        :picker-options="end_Date"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        placeholder="选择日期时间">
                        </el-date-picker>
                    </div>
                    <div class="item">
                        <div class="label">
                            案件状态
                        </div>
                        <div class="value">
                            <el-select v-model="caseData.dcTaskAction" size="small" placeholder="请选择"  class="citem-input" @change="changeCompany">
                                <el-option
                                v-for="item in DcTaskActionList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                </div>
                <div class="section">
                    <div class="title">
                        保险信息
                    </div>
                    <div class="item">
                        <div class="label">
                            <span class="dot">*</span>
                            保险公司
                        </div>
                        <div class="value">
                            <el-select v-model="caseData.companyId" size="small" placeholder="请选择"  class="citem-input" @change="changeCompany">
                                <el-option
                                v-for="item in companyList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="item">
                        <div class="label">
                        委托人
                        </div>
                        <div class="value">
                            <el-input v-model="caseData.entrustName" placeholder="请输入" size="small" class="citem-input"></el-input>
                        </div>
                    </div>
                    <div class="item">
                        <div class="label">
                            <span class="dot">*</span>
                            险种类型
                        </div>
                        <div class="value">
                            <el-select v-model="caseData.cProdType" size="small" placeholder="请选择"  class="citem-input">
                                <el-option
                                v-for="item in insuranceList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="item">
                        <div class="label">
                            <span class="dot">*</span>
                            保障产品
                        </div>
                        <div class="value">
                            <el-select v-model="caseData.cProdName" size="small" placeholder="请选择"  class="citem-input">
                                <el-option
                                v-for="item in productList"
                                :key="item.name"
                                :label="item.name"
                                :value="item.name">
                                </el-option>
                            </el-select>
                            <!-- <el-input v-model="caseData.cProdName" placeholder="请输入" size="small" class="citem-input"></el-input> -->
                        </div>
                    </div>
                    <div class="item">
                        <div class="label">
                            保单号
                        </div>
                        <div class="value">
                            <el-input v-model="caseData.cPlyNo" placeholder="请输入" size="small" class="citem-input"></el-input>
                        </div>
                    </div>
                    <div class="item">
                        <div class="label">
                            投保时间
                        </div>
                        <el-date-picker
                        v-model="caseData.tInsAddTm"
                        type="datetime"
                        size="small"
                        class="citem-input"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        placeholder="选择日期时间">
                        </el-date-picker>
                    </div>
                    <div class="item">
                        <div class="label">
                            <span class="dot">*</span>
                            被保人
                        </div>
                        <div class="value">
                            <el-input v-model="caseData.cInsuredNme" placeholder="请输入" size="small" class="citem-input"></el-input>
                        </div>
                    </div>
                    <div class="item">
                        <div class="label">
                            <span class="dot">*</span>
                            被保人证件类型
                        </div>
                        <div class="value">
                            <el-select v-model="caseData.cCertType" size="small" placeholder="请选择"  class="citem-input">
                                <el-option
                                v-for="item in InsuredNoTypeList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                    
                   
                    <div class="item">
                        <div class="label">
                            <span class="dot">*</span>
                            被保人证件号
                        </div>
                        <div class="value">
                            <el-input v-model="caseData.cCertNo" placeholder="请输入" size="small" class="citem-input"></el-input>
                        </div>
                    </div>
                </div>

                <div class="section">
                    <div class="title">
                        出险信息
                    </div>
                    <div class="item">
                        <div class="label">
                            <span class="dot">*</span>
                            出险人
                        </div>
                        <div class="value">
                            <el-input v-model="caseData.personDanger" placeholder="" size="small"></el-input>
                        </div>
                    </div>
                    <div class="item">
                        <div class="label">
                            出险时间
                        </div>
                        <div class="value">
                            <el-date-picker
                            v-model="caseData.tAccdntTm"
                            type="datetime"
                            size="small"
                            class="citem-input"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="选择日期时间">
                            </el-date-picker>
                        </div>
                    </div>
                    <div class="item">
                        <div class="label">
                            出险地点
                        </div>
                        <div class="value">
                            <el-cascader
                            size="small"
                            :options="regionData"
                            v-model="selectedOptions"
                            @change="handleRegionChange">
                            </el-cascader>
                        </div>
                    </div>
                    <div class="item">
                        <div class="label">
                            出险经过
                        </div>
                        <div class="value" style="width:590px">
                            <el-input v-model="caseData.cAccdntPro" placeholder="请输入" size="small" type="textarea"></el-input>
                        </div>
                    </div>
                    
                </div>
                <div class="section">
                    <div class="title">
                        报案信息
                    </div>
                    <div class="item">
                        <div class="label">
                            报案人
                        </div>
                        <div class="value">
                            <el-input v-model="caseData.cRptName" placeholder="请输入" size="small" class="citem-input"></el-input>
                        </div>
                    </div>
                    <div class="item">
                        <div class="label">
                            报案人电话
                        </div>
                        <div class="value">
                            <el-input v-model="caseData.cRptTell" placeholder="请输入" size="small" class="citem-input"></el-input>
                        </div>
                    </div>
                   
                    <div class="item">
                        <div class="label">
                            报案时间
                        </div>
                        <el-date-picker
                        v-model="caseData.tRptTm"
                        type="datetime"
                        size="small"
                        class="citem-input"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        placeholder="选择日期时间">
                        </el-date-picker>
                    </div>
                    
                    
                </div>
                <!-- <div class="section">
                    <div class="title">
                        公估费用
                    </div>
                    <div class="item">
                        <div class="label">
                            公估费用:
                        </div>
                        <div class="value">
                            <el-input v-model="caseData.appraisalFee" placeholder="请输入" size="small" class="citem-input"></el-input>
                        </div>
                    </div>
                </div> -->
                
            </el-tab-pane>
            <el-tab-pane label="派工信息">
                <div style="margin:0 10px;width:100%">
                    <div class="handle">
                        <div>
                            <el-button type="primary" icon="el-icon-circle-plus" size="small" @click="addSurveyDataDialog=true">添加调查信息</el-button>
                        </div>
                    </div>
                    <el-table
                        :data="surveyData"
                        border
                        :header-cell-style="tableHeaderColor"
                        style="width:100%"
                        >
                        <el-table-column
                        type="index"
                        label="序号"
                        width="60"
                        align="center"
                        >
                        </el-table-column>
                       
                        <el-table-column
                        prop="cSvyNeed"
                        label="调查需求"
                        align="center"
                        >
                        </el-table-column>
                        
                        <el-table-column
                        prop="tHopeEndTm"
                        label="期望完成时间"
                        align="center"
                        width="200">
                        <template slot-scope="scope">
                            <span style="color:red">{{scope.row.tHopeEndTm}}</span>
                        </template>
                        </el-table-column>
                        <el-table-column
                        prop="cSvyType"
                        label="疑似类型"
                        align="center"
                        width="150">
                        </el-table-column>
                        <el-table-column
                        prop="cSvyMode"
                        label="案件类型"
                        align="center"
                        width="120">
                        </el-table-column>
                        <el-table-column
                        prop="cSvyPlace"
                        label="调查地点"
                        align="center"
                        width="180"
                        >
                        </el-table-column>
                        
                        <el-table-column
                        prop="cSvyAddr"
                        label="调查地址"
                        align="center"
                        width="240"
                        >
                        </el-table-column>
                        <el-table-column
                        prop="creationTime"
                        label="创建时间"
                        align="center"
                        width="180"
                        >
                        </el-table-column>
                        
                        <el-table-column
                        fixed="right"
                        label="操作"
                        width="180px"
                        align="center"
                        >
                        <template slot-scope="scope">
                            <el-button type="text" icon="el-icon-edit" size="mini" @click="surveyDataItemDialogOpen(scope.row,scope.$index)">编辑</el-button>
                        </template>
                        </el-table-column>
                    </el-table>
                </div>
            </el-tab-pane>
            <el-tab-pane label="派工资料">
                <div style="margin:0 10px;width:100%">
                    <div class="materiallist">
                        <div class="material" v-for="(item,index) in surveyInfo" :key="index">
                            <img src="../../../assets/images/icon11.png" alt="" v-if="item.materialType=='mp3'||item.materialType=='aac'||item.materialType=='wav'||item.materialType=='wma'||item.materialType=='flac'||item.materialType=='ape'" :fit="cover" @click="download(item.path,item.name)">
                            <img src="../../../assets/images/icon12.png" alt="" v-else-if="item.materialType=='rmvb'||item.materialType=='rm'||item.materialType=='ts'||item.materialType=='tp'||item.materialType=='avi'||item.materialType=='3gp'||item.materialType=='mp4'||item.materialType=='mkv'" :fit="cover" @click="download(item.path,item.name)">
                            <img src="../../../assets/images/icon13.png" alt="" v-else-if="item.materialType=='xls'||item.materialType=='xlsx'||item.materialType=='doc'||item.materialType=='docx'||item.materialType=='ppt'||item.materialType=='pptx'||item.materialType=='pdf'||item.materialType=='zip'||item.materialType=='rar'" :fit="cover" @click="download(item.path,item.name)">
                            <el-image
                            style="width: 120px; height: 120px"
                            :src="item.path"
                            v-else
                            @click="showImgM(item.path,surveyInfo)"
                            :fit="cover"></el-image>
                            <img src="../../../assets/images/icon08.png" class="close" @click="clearSurveyInfoMaterial(index)" alt="" >
                            <div class="filename">{{item.name}}</div>
                        </div>

                        <div>
                            <el-upload
                                :action="uploadUrl"
                                multiple
                                :show-file-list="false"
                                :http-request="addSurveyInfo"
                                >
                                <el-button type="primary" icon="el-icon-circle-plus-outline">新增</el-button>
                            </el-upload>
                        </div>
                    </div>
                   
                </div>
            </el-tab-pane>
        </el-tabs>
        
        
        
       
       <el-dialog :close-on-click-modal="false" :visible.sync="surveyDataItemDialog" title="调查信息详情" width="800px">
            <div class="section">
                <div class="title">
                    调查信息
                </div>
                <div class="item">
                    <div class="label">
                        调查需求
                    </div>
                    <div class="value" style="width:590px">
                        
                        <el-autocomplete
                            class="inline-input"
                            v-model="surveyDataItem.cSvyNeed"
                            :fetch-suggestions="querySearch"
                            placeholder=""
                            @select="handleSelect"
                            @keyup.enter.native="search"
                            size="small"
                        >
                            <template slot-scope="{ item }">
                                <div class="name">{{ item.label }}</div>
                            </template>
                        </el-autocomplete>
                    </div>
                </div>
                
                <div class="item">
                    <div class="label">
                        期望完成时间
                    </div>
                    <div class="value">
                        <el-date-picker
                        v-model="surveyDataItem.tHopeEndTm"
                        type="date"
                        size="small"
                        class="citem-input"
                        format="yyyy-MM-dd"
                        placeholder="选择日期时间">
                        </el-date-picker>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        疑案类型
                    </div>
                    <div class="value">
                        <el-select v-model="surveyDataItem.cSvyTypeCode" size="small" placeholder="请选择"  class="citem-input" @change="changeCSvyType">
                            <el-option
                            v-for="item in cSvyTypeList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        案件类型
                    </div>
                    <div class="value">
                        <el-select v-model="surveyDataItem.cSvyModeCode" size="small" placeholder="请选择"  class="citem-input" @change="changeCSvyMode">
                            <el-option
                            v-for="item in cSvyModeList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        调查地点
                    </div>
                    <div class="value">
                        <el-select v-model="surveyDataItem.cSvyPlaceCode" size="small" placeholder="请选择"  class="citem-input" @change="changeCSvyPlace">
                            <el-option
                            v-for="item in cSvyPlaceList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        调查地址
                    </div>
                    <div class="value">
                        <el-input v-model="surveyDataItem.cSvyAddr" placeholder="请输入" size="small"></el-input>
                    </div>
                </div>
                
                <!-- <div class="item">
                    <div class="label">
                        调查内容
                    </div>
                    <div class="value" style="width:590px">
                        <el-input v-model="assignData.cDoubtOpin" placeholder="请输入" size="small" type="textarea"></el-input>
                    </div>
                </div> -->
               
            </div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" :visible.sync="addSurveyDataDialog" title="新增调查信息详情" width="800px">
            <div class="section">
                <div class="title">
                    调查信息
                </div>
                <div class="item">
                    <div class="label">
                        调查需求
                    </div>
                    <div class="value" style="width:590px">
                        <el-select v-model="addSurveyData.cSvyNeed" size="small" placeholder="请选择"  class="citem-input" @change="changeCSvyNeed">
                            <el-option
                            v-for="item in cSvyNeedList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                
                <div class="item">
                    <div class="label">
                        期望完成时间
                    </div>
                    <div class="value">
                        <el-date-picker
                        v-model="addSurveyData.tHopeEndTm"
                        type="date"
                        size="small"
                        class="citem-input"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期时间">
                        </el-date-picker>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        疑案类型
                    </div>
                    <div class="value">
                        <el-select v-model="addSurveyData.cSvyTypeCode" size="small" placeholder="请选择"  class="citem-input" @change="changeCSvyType">
                            <el-option
                            v-for="item in cSvyTypeList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        案件类型
                    </div>
                    <div class="value">
                        <el-select v-model="addSurveyData.cSvyModeCode" size="small" placeholder="请选择"  class="citem-input" @change="changeCSvyMode">
                            <el-option
                            v-for="item in cSvyModeList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        调查地点
                    </div>
                    <div class="value">
                        
                        <el-select v-model="addSurveyData.cSvyPlaceCode" size="small" placeholder="请选择"  class="citem-input" @change="changeCSvyPlace">
                            <el-option
                            v-for="item in cSvyPlaceList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        调查地址
                    </div>
                    <div class="value">
                        <el-input v-model="addSurveyData.cSvyAddr" placeholder="请输入" size="small"></el-input>
                    </div>
                </div>
                
               <div class="btns">
                    <el-button type="primary" icon="el-icon-edit" @click="addSurveyDataFun">确认新增</el-button>
                </div>
            </div>
        </el-dialog>
        <div class="btn-bottom">
            <el-button type="primary" icon="el-icon-circle-plus" @click="updateAnXinDcTask">确认编辑</el-button>
        </div>
        <!-- 大图预览 -->
        <el-image-viewer
            v-if="showBigImg"
            :on-close="closeViewer"
            :url-list="showBigImgList"
            :initial-index="imgIndex"
        />
    </div>
</template>
<script>
import api from '../../../api/main'
import { TextToCode , CodeToText , regionData} from "element-china-area-data";
import { cCourPlaceList , cCourProList , cCourRelaList,InsuredNoTypeList,CCourModeList ,RefuseRsnList  ,cSvyNeedList,cSvyModeList,cSvyPlaceList,cSvyTypeList,insuranceList, DcTaskActionList} from "../../../assets/selectList/anxin";
import { parseTimeS,isPhoneNumber } from "../../../utils/index";
 import "../../../utils/dialog"
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
export default {
    name: 'index',
    components:{
        ElImageViewer
    },
    watch: {
    },
    data () {
        return {
            DcTaskActionList:DcTaskActionList,
            insuranceList:insuranceList,
            cSvyNeedList:cSvyNeedList,
            cSvyModeList:cSvyModeList,
            cSvyPlaceList:cSvyPlaceList,
            cSvyTypeList:cSvyTypeList,
            
            uploadUrl:'',
            regionData:regionData,
            InsuredNoTypeList:InsuredNoTypeList,
            caseData:{
                companyId:'',
                companyName:'',
                cProdName:'',
            },
            selectedOptions:[],
            isAddDoubtCourse:false,

            surveyInfo:[],//资料
           
           
            isEditDoubtCourse:false,
            isAddDoubtCourse:false,
            surveyDataItemDialog:false,
            surveyDataItem:{},
            surveyDataIndex:0,
            
            surveyData:[],//信息

            addSurveyData:{},
            addSurveyDataDialog:false,

            companyList:[],

            showBigImg:false,
            showBigImgList:[],

            appraisalFee:null,



            end_Date:{
                disabledDate:time => {
                    
                    return time.getTime() >= Date.now()+10
                }
            }

        }
    },
    created(){
        

    },
    mounted(){
        this.getCompanyList();

        this.queryAnXinDcTaskByAnXinDcTaskId();
        this.queryAnXinDoubtDetailByAnXinDcTaskId();
        this.queryAnXinCaseMaterialItemByAnXinDcTaskId();


    },
    methods:{
        changeTab(e){
            if(e.index==0){
                this.queryAnXinDcTaskByAnXinDcTaskId();
            }
            if(e.index==1){
                this.queryAnXinDoubtDetailByAnXinDcTaskId();
            }
            if(e.index==2){
                this.queryAnXinCaseMaterialItemByAnXinDcTaskId();
            }
        },
        // 调查信息查询
        surveyDataItemDialogOpen(detail,index){
            console.log(index);
            this.surveyDataIndex = index;
            this.surveyDataItemDialog = true;
            this.surveyDataItem = detail;
        },
        // 调查任务Id查询调查信息
        async queryAnXinDoubtDetailByAnXinDcTaskId(){
            let res = await api.queryAnXinDoubtDetailByAnXinDcTaskId(this.$route.query.id);
            this.surveyData = res.data.data;
        },
         // 调查任务Id查询调查资料
        async queryAnXinCaseMaterialItemByAnXinDcTaskId(){
            let res = await api.queryAnXinCaseMaterialItemByAnXinDcTaskId(this.$route.query.id);
            this.surveyInfo = res.data.data;
        },
        async getCompanyList() {
            let res  = await api.queryCompany(this.conditionData);
            console.log(res);
            this.companyList = res.data.data;
        },
        async productDetail(row){
            let res  = await api.queryCompanyProduct(row.id);
            this.productList = res.data.data;
            this.$forceUpdate();
        },
        async queryAnXinDcTaskByAnXinDcTaskId(){
            let res = await api.queryAnXinDcTaskByAnXinDcTaskId(this.$route.query.id);
            this.caseData = res.data.data;
            // this.surveyData = this.caseData.doubtCourseList?this.caseData.doubtCourseList:[]
            // this.surveyInfo = this.caseData.doubTaskMaterialItems?this.caseData.doubTaskMaterialItems:[]
            console.log(this.caseData.cAccdntPlace);
            let cAccdntPlaceList = this.caseData.cAccdntPlace.split('-');
            console.log(cAccdntPlaceList);
            if(cAccdntPlaceList[2]){
                this.selectedOptions = [TextToCode[cAccdntPlaceList[0]].code,TextToCode[cAccdntPlaceList[0]][cAccdntPlaceList[1]].code,TextToCode[cAccdntPlaceList[0]][cAccdntPlaceList[1]][cAccdntPlaceList[2]].code];
                return;
            }
            if(cAccdntPlaceList[1]){
                this.selectedOptions = [TextToCode[cAccdntPlaceList[0]].code,TextToCode[cAccdntPlaceList[0]][cAccdntPlaceList[1]].code ];
            }
            console.log(this.selectedOptions);
        },
        handleRegionChange(){
            let e = this.selectedOptions;
            if(e[2]){
                this.caseData.cAccdntPlace = CodeToText[e[0]]+'-'+CodeToText[e[0],e[1]]+'-'+CodeToText[e[0],e[1],e[2]]
            }else if(e[1]){
                this.caseData.cAccdntPlace = CodeToText[e[0]]+'-'+CodeToText[e[0],e[1]]
            }
            // this.caseData.cCourAll=this.selectedOptions;
            // for(let index in this.caseData.cCourAll){
            //     this.caseData.cCourAll[index] = parseInt(this.caseData.cCourAll[index]);
            // }
        },
        
        // 图片查看
        closeViewer(){
            this.showBigImg = false;
        },
        showImg(img,list){
            let imglist = [];
            for(let i in list){
                if(list[i].fileType=='jpg'||list[i].fileType=='png'||list[i].fileType=='gif'||list[i].fileType=='jpeg'||list[i].fileType=='JPG'||list[i].fileType=='PNG'||list[i].fileType=='GIF'||list[i].fileType=='JPEG'){
                    imglist.push(list[i].path);
                    if(img==list[i].path){
                        this.imgIndex = imglist.length-1
                    }
                }
            }
            this.showBigImgList = imglist;
            this.showBigImg = true;
        },
        showImgM(img,list){
            let imglist = [];
            for(let i in list){
                if(list[i].materialType=='jpg'||list[i].materialType=='png'||list[i].materialType=='gif'||list[i].materialType=='jpeg'||list[i].materialType=='JPG'||list[i].materialType=='PNG'||list[i].materialType=='GIF'||list[i].materialType=='JPEG'){
                    imglist.push(list[i].path);
                    if(img==list[i].path){
                        this.imgIndex = imglist.length-1
                    }
                }
            }
            this.showBigImgList = imglist;
            this.showBigImg = true;
        },
        
        tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #F2F2F2;color: #000;'
            }
        },
       
       
        // 选择公司
        changeCompany(e){
            for(let index in this.companyList){
                if(this.companyList[index].id==e){
                    this.caseData.companyName = this.companyList[index].name
                    this.caseData.cProdName = '';
                    this.productDetail({id:e});
                    return;

                }
            }
        },
        
        
        
        
        
       

        
        
        
        
        // 上传
        async uploadCPath(file){
            let name = file.file.name;
            let fileTypeList = name.split('.');
            let fileType = fileTypeList[fileTypeList.length-1];
            this.addCaseMaterial.fileType = fileType;
            let res = await api.uploadOther(file.file);
            this.addCaseMaterial.path = res;
            this.$forceUpdate();
            console.log(res);

        },
        
        // 下载资料
        download(path,name){
            this.$message({
                type: 'success',
                message: '下载成功,请稍等!'
            });
            const elt = document.createElement('a');
            elt.setAttribute('target', '_blank');
            elt.setAttribute('href', path);
            elt.setAttribute('download', name);
            elt.style.display = 'none';
            document.body.appendChild(elt);
            elt.click();
        },
       


        
        

        async cProcessDetail(detail){
            console.log(detail);
            this.cProcess = detail;
            this.cProcessDetailDialog = true;
        },




        addSurveyDataFun(){
            console.log(this.addSurveyData);
            
            this.surveyData.push({
                cSvyNeed:this.addSurveyData.cSvyNeed,
                cSvyNeedCode:this.addSurveyData.cSvyNeed,
                tHopeEndTm:this.addSurveyData.tHopeEndTm,
                cSvyType:this.addSurveyData.cSvyType,
                cSvyTypeCode:this.addSurveyData.cSvyTypeCode,
                cSvyMode:this.addSurveyData.cSvyMode,
                cSvyModeCode:this.addSurveyData.cSvyModeCode,
                cSvyPlace:this.addSurveyData.cSvyPlace,
                cSvyPlaceCode:this.addSurveyData.cSvyPlaceCode,
                cSvyAddr:this.addSurveyData.cSvyAddr,
            });
            this.addSurveyDataDialog = false;
            this.updateAnXinDcTask();
            this.$forceUpdate();
        },
        // 编辑调查信息
        editSurveyDataFun(){
            console.log(this.surveyDataItem);
            this.surveyData[this.surveyDataIndex] = this.surveyDataItem;
            this.surveyDataItemDialog = false;
            this.updateAnXinDcTask();
            this.$forceUpdate();
        },
        async addSurveyInfo(file){
            let material = {
                // anXinDcTaskId:this.detailData.id,
                materialType:'',
                name:'',
                path:'',
            };
            material.name = file.file.name;
            let fileTypeList = material.name.split('.');
            let fileType = fileTypeList[fileTypeList.length-1];
            material.materialType = fileType;
            let res = await api.uploadOther(file.file);
            console.log(res)
            material.path = res;
            if(this.surveyInfo){
                this.surveyInfo.push(material);
            }else{
                this.surveyInfo=[material];
            }
        },

        
        clearSurveyInfoMaterial(index){
            this.surveyInfo.splice(index,1);
        },

        async updateAnXinDcTask(){
            if(!this.caseData.cClmNo){
                this.$message({
                    type: 'warning',
                    message: '请填写赔案号!'
                });
                return;
            }
            // if(!this.caseData.cDoubtOpin){
            //     this.$message({
            //         type: 'warning',
            //         message: '请填写调查意见!'
            //     });
            //     return;
            // }
            if(!this.caseData.companyId){
                this.$message({
                    type: 'warning',
                    message: '请填写保险公司!'
                });
                return;
            }
            if(!this.caseData.cProdType){
                this.$message({
                    type: 'warning',
                    message: '请填写险种类型!'
                });
                return;
            }
            if(!this.caseData.cProdName){
                this.$message({
                    type: 'warning',
                    message: '请填写保障产品!'
                });
                return;
            }
            // if(!this.caseData.cPlyNo){
            //     this.$message({
            //         type: 'warning',
            //         message: '请填写保单号!'
            //     });
            //     return;
            // }
            // if(!this.caseData.tInsAddTm){
            //     this.$message({
            //         type: 'warning',
            //         message: '请填写投保时间!'
            //     });
            //     return;
            // }
            if(!this.caseData.cInsuredNme){
                this.$message({
                    type: 'warning',
                    message: '请填写被保人!'
                });
                return;
            }
            if(!this.caseData.cCertType){
                this.$message({
                    type: 'warning',
                    message: '请填写被保人证件类型!'
                });
                return;
            }
            if(!this.caseData.cCertNo){
                this.$message({
                    type: 'warning',
                    message: '请填写被保人证件号!'
                });
                return;
            }
            if(!this.caseData.personDanger){
                this.$message({
                    type: 'warning',
                    message: '请填写出险人!'
                });
                return;
            }
            // if(!this.caseData.tAccdntTm){
            //     this.$message({
            //         type: 'warning',
            //         message: '请填写出险时间!'
            //     });
            //     return;
            // }
            // if(!this.caseData.cAccdntPlace){
            //     this.$message({
            //         type: 'warning',
            //         message: '请填写出险地点!'
            //     });
            //     return;
            // }
            // if(!this.caseData.cAccdntPro){
            //     this.$message({
            //         type: 'warning',
            //         message: '请填写出险经过!'
            //     });
            //     return;
            // }
            // if(!this.caseData.cRptTell){
            //     this.$message({
            //         type: 'warning',
            //         message: '请填写报案人电话!'
            //     });
            //     return;
            // }
            // if(!this.caseData.tRptTm){
            //     this.$message({
            //         type: 'warning',
            //         message: '请填写报案时间!'
            //     });
            //     return;
            // }
            if(!this.caseData.dcTaskPgTime){
                this.$message({
                    type: 'warning',
                    message: '请填写派工时间!'
                });
                return;
            }
            // if(!this.caseData.cRptName){
            //     this.$message({
            //         type: 'warning',
            //         message: '请填写报案人!'
            //     });
            //     return;
            // }
            if(this.surveyData.length==0){
                this.$message({
                    type: 'warning',
                    message: '请填写派工信息!'
                });
                return;
            }
            this.addSurveyData = {};
            this.caseData.materialItems = this.surveyInfo?this.surveyInfo:[];
            this.caseData.anXinDoubtDetails = this.surveyData?this.surveyData:[];
            this.caseData.appraisalFee = parseFloat(this.caseData.appraisalFee?this.caseData.appraisalFee:0);
            // if(!isPhoneNumber(this.caseData.cRptTell)){
            //     this.$message({
            //         type: 'error',
            //         message: '报案人手机号格式不对'
            //     });  
            //     return;
            // }
            let res = await api.updateAnXinDcTask(this.caseData);
            if(res.data.code == '200'){
                 this.$message({
                    type: 'success',
                    message: '编辑成功'
                });  
                this.anXinDcTaskUpdateDcTaskAction();
            }
        },

        async anXinDcTaskUpdateDcTaskAction(){
            let res = await api.anXinDcTaskUpdateDcTaskAction({
                anXinDcTaskId:this.$route.query.id,
                dcTaskAction:this.caseData.dcTaskAction,
            });
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '编辑成功'
                });  
            }
        },
        changeCSvyPlace(e){
            for(let index in this.cSvyPlaceList){
                if(this.cSvyPlaceList[index].value==e){
                    if(this.surveyDataItemDialog){
                        this.surveyDataItem.cSvyPlace = this.cSvyPlaceList[index].label
                    }else if (this.addSurveyDataDialog) {
                        this.addSurveyData.cSvyPlace = this.cSvyPlaceList[index].label
                    }
                    return;
                }
            }
        },
        changeCSvyNeed(e){
            for(let index in this.cSvyNeedList){
                if(this.cSvyNeedList[index].value==e){
                    if(this.surveyDataItemDialog){
                        this.surveyDataItem.cSvyNeed = this.cSvyNeedList[index].label
                    }else if (this.addSurveyDataDialog) {
                        this.addSurveyData.cSvyNeed = this.cSvyNeedList[index].label
                    }
                    return;

                }
            }
        },
        changeCSvyType(e){
            for(let index in this.cSvyTypeList){
                if(this.cSvyTypeList[index].value==e){
                    if(this.surveyDataItemDialog){
                        this.surveyDataItem.cSvyType = this.cSvyTypeList[index].label
                    }else if (this.addSurveyDataDialog) {
                        this.addSurveyData.cSvyType = this.cSvyTypeList[index].label
                    }
                    return;

                }
            }
        },
        changeCSvyMode(e){
            for(let index in this.cSvyModeList){
                if(this.cSvyModeList[index].value==e){
                    if(this.surveyDataItemDialog){
                        this.surveyDataItem.cSvyMode = this.cSvyModeList[index].label
                    }else if (this.addSurveyDataDialog) {
                        this.addSurveyData.cSvyMode = this.cSvyModeList[index].label
                    }
                    return;

                }
            }
        },

        // 查询
        async querySearch(queryString, cb){
            let list = this.cSvyNeedList;
            console.log(queryString);
            let results = queryString ? list.filter(this.createFilter(queryString)) : list;
            console.log(results);
            cb(results);
        },
        handleSelect(e){
            console.log(e);
            if(this.surveyDataItemDialog){
                this.surveyDataItem.cSvyNeed = e.label;
                this.surveyDataItem.cSvyNeedCode = e.label;
            }else if (this.addSurveyDataDialog) {
                this.addSurveyData.cSvyNeed = e.label;
                this.addSurveyData.cSvyNeedCode = e.label;
            }
        },
        createFilter(queryString) {
            return (list) => {
                return (list.label.toLowerCase().indexOf(queryString.toLowerCase()) != -1);
            };
        },
       
    }
    
}
</script>

<style lang="scss" scoped>
    /deep/.el-input.is-disabled .el-input__inner{
        color:#606266;
    }
    .top{
        display: flex;
        justify-content: space-between;
        padding:10px;
        background-color: #ffffff;
    }
    .handle{
        margin-bottom: 10px;
    }
    .dialog-btn{
        width: 100%;
        display: flex;
        justify-content: center;
    }
    .section{
        height: 100%;
        display: flex;
        flex-wrap: wrap;
        border: 1px solid #DEDEDE;
        margin-bottom: 15px;
        padding-bottom: 10px;
        .title{
            width: 100%;
            font-weight: bold;
            font-size: 16px;
            margin-bottom: 12px;
            background-color: #DEDEDE;
            padding:8px 15px;
        }
        .item{
            font-size: 14px;
            padding:10px 15px;
            display: flex;
            align-items: center;
            .label{
                margin-bottom: 5px;
                width: 120px;
                display: flex;
                align-items: center;
                .dot{
                    color: red;
                    font-size: 20px;
                }
            }
            .value{
                width: 220px;
            }
            .piclist{
                width: 100%;
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                padding:10px 15px;
                .label{
                    width: 230px;
                    font-size: 14px;
                }
                .pics{
                    display: flex;
                    flex-wrap: wrap;
                    .pics-item{
                        width: 100px;
                        height: 100px;
                        position: relative;
                        margin: 15px;
                        .img{
                            width: 100px;
                            height: 100px;
                        }
                        .close{
                            position: absolute;
                            top: -12px;
                            right: -12px;
                            width: 24px;
                            height: 24px;
                        }
                    }
                }
                .uploadbtn{
                    border: 1px solid #dcdcdc;
                    width: 106px;
                    height: 106px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin: 15px;
                    img{
                        width: 106px;
                        height: 106px;
                    }
                }
                
            }
        }
    
    }
    .item{
        font-size: 14px;
        padding:10px 15px;
        display: flex;
        align-items: center;
        .label{
            margin-bottom: 5px;
            width: 120px;
        }
        .inline-input{
            width: 100%;
        }
        .value{
            width: 220px;
            display: flex;
        }
        .piclist{
            width: 100%;
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            padding:10px 15px;
            .label{
                width: 230px;
                font-size: 14px;
            }
            .pics{
                display: flex;
                flex-wrap: wrap;
                .pics-item{
                    width: 100px;
                    height: 100px;
                    position: relative;
                    margin: 15px;
                    .img{
                        width: 100px;
                        height: 100px;
                    }
                    .close{
                        position: absolute;
                        top: -12px;
                        right: -12px;
                        width: 24px;
                        height: 24px;
                    }
                }
            }
            .uploadbtn{
                border: 1px solid #dcdcdc;
                width: 106px;
                height: 106px;
                display: flex;
                align-items: center;
                justify-content: center;
                margin: 15px;
                img{
                    width: 106px;
                    height: 106px;
                }
            }
            
        }
    }
    .btns{
        width: 100%;
        display: flex;
        justify-content: center;
    }
    .taskreason{
        span{
            color: red;
            font-size: 18px;
        }
        font-size: 14px;
        margin: 10px 0;
    }
    .materiallist{
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 15px;
        align-items: center;
        .material{
            border: 1px dashed #dcdcdc;
            width: 150px;
            height: 170px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
            border-radius: 4px;
            margin:10px;
            position: relative;
            img{
                width: 120px;
            }
            .close{
                width: 25px;
                height: 25px;
                position: absolute;
                right: 3px;
                top: 3px;
            }
            .filename{
                width: 130px;
                font-size: 12px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                text-align: center;
                margin-top: 2px;
            }
        }
    }
    .section-item{
        display: flex;
        flex-wrap: wrap;
        border: 1px solid #DEDEDE;
        margin-bottom: 10px;
        .stitle{
            background-color: #f1f1f1;
            width: 100%;
            font-weight: bold;
            font-size: 16px;
            margin-bottom: 12px;
            border-bottom:1px solid #DEDEDE;
            padding:8px 15px;
            
        }
        
    }
    /deep/.el-step.is-simple .el-step__title{
        font-size: 14px;
    } 
    /deep/.el-steps--simple{
        padding:  0px;
        background-color: #ffffff;
    }
    /deep/.el-steps{
        width: 1000px;
    }
    /deep/.el-step.is-simple .el-step__arrow::after, /deep/.el-step.is-simple .el-step__arrow::before{
        height: 9px !important;
    }
    
    /deep/.el-step.is-simple .el-step__arrow::after{
        transform: rotate(45deg) translateY(3px);
    }
    /deep/.el-step.is-simple .el-step__arrow::before{
        transform: rotate(-45deg) translateY(-3px);
    }
    .btn-bottom{
        display: flex;
        justify-content: center;
        margin-top: 50px;
    }
</style>
